var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransferenciaAceita(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3747 3.12489H5.00016V1.24995C5.00016 0.997458 4.84766 0.768716 4.61392 0.672469C4.38018 0.576222 4.11268 0.62997 3.93269 0.807464L0.182807 4.55735C-0.0609356 4.80109 -0.0609356 5.19733 0.182807 5.44107L3.93269 9.19095C4.11268 9.3697 4.38018 9.42345 4.61392 9.3272C4.84766 9.23095 5.00016 9.00221 5.00016 8.74972V6.87478H19.3747C19.7197 6.87478 19.9997 6.59478 19.9997 6.24979V3.74987C19.9997 3.40363 19.7197 3.12489 19.3747 3.12489Z",
    fill: "#30D158"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8171 14.558L16.0672 10.8068C15.8885 10.6281 15.6198 10.5743 15.386 10.6718C15.1523 10.7693 14.9998 10.9968 14.9998 11.2493V13.1243H0.625225C0.280235 13.1243 0.000244141 13.4042 0.000244141 13.7492V16.2491C0.000244141 16.5941 0.280235 16.8741 0.625225 16.8741H14.9998V18.7491C14.9998 19.0016 15.1523 19.2303 15.386 19.3265C15.6198 19.424 15.8885 19.3703 16.0672 19.1916L19.8171 15.4417C20.0609 15.1979 20.0609 14.8017 19.8171 14.558Z",
    fill: "#30D158"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferenciaAceita);
export default __webpack_public_path__ + "static/media/transferencia-aceita.82b7a620.svg";
export { ForwardRef as ReactComponent };